import { render, staticRenderFns } from "./TypeTag.vue?vue&type=template&id=8a76ba5e&"
import script from "./TypeTag.vue?vue&type=script&lang=js&"
export * from "./TypeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports